import { collection, getDocs, orderBy, query, Timestamp, writeBatch, doc } from 'firebase/firestore';
import { db } from '../../../firebase';
import type { TriggerLog } from './triggerLogTypes';

export class TriggerLogService {
    private static instance: TriggerLogService;

    static getInstance(): TriggerLogService {
        if (!TriggerLogService.instance) {
            TriggerLogService.instance = new TriggerLogService();
        }
        return TriggerLogService.instance;
    }

    async getTriggerLogs(userId: string): Promise<TriggerLog[]> {
        const triggerLogsRef = collection(db, `user_info/${userId}/trigger_logs`);
        const q = query(triggerLogsRef, orderBy('createdAt', 'desc'));

        const querySnapshot = await getDocs(q);

        return querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
                id: doc.id,
                obsession: data.obsession,
                compulsion: data.compulsion,
                trigger: data.trigger,
                duration: data.duration,
                createdAt: (data.createdAt as Timestamp).toDate(),
            };
        });
    }

    async deleteAllTriggerLogs(userId: string): Promise<void> {
        const triggerLogsRef = collection(db, `user_info/${userId}/trigger_logs`);
        const querySnapshot = await getDocs(triggerLogsRef);

        const batch = writeBatch(db);
        querySnapshot.docs.forEach((document) => {
            const docRef = doc(db, `user_info/${userId}/trigger_logs`, document.id);
            batch.delete(docRef);
        });
        await batch.commit();
    }
}

export const triggerLogService = TriggerLogService.getInstance();
